import { render } from "./CampaignsDetailKPIs.vue?vue&type=template&id=ebd87b64&scoped=true"
import script from "./CampaignsDetailKPIs.vue?vue&type=script&lang=js"
export * from "./CampaignsDetailKPIs.vue?vue&type=script&lang=js"

import "./CampaignsDetailKPIs.vue?vue&type=style&index=0&id=ebd87b64&lang=scss&scoped=true"
import "./CampaignsDetailKPIs.vue?vue&type=style&index=1&id=ebd87b64&lang=scss"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ebd87b64"]])

export default __exports__